import { render, staticRenderFns } from "./TopTradedShares.vue?vue&type=template&id=7a598220&scoped=true&"
import script from "./TopTradedShares.js?vue&type=script&lang=js&"
export * from "./TopTradedShares.js?vue&type=script&lang=js&"
import style0 from "./TopTradedShares.vue?vue&type=style&index=0&id=7a598220&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a598220",
  null
  
)

export default component.exports